import gql from 'graphql-tag';

export default gql`
  fragment blastengineMailCampaignMailClickProspectActivityFragment on BlastengineMailCampaignMailClickProspectActivity {
    id
    mailCampaignUrl {
      id
      url
    }
    mailCampaignSendShortUrl {
      id
      urlPlaceholder
    }
    mailCampaignSend {
      id
      createdAt
      mailCampaign {
        id
        uuid
        title
        subject
        fromAddress
        fromName
        cc
        bcc
        sendAt
        isImmediately
        pool {
          uuid
        }
      }
    }
  }
`;
